/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getGraphicsScene} from '../api'

 export const useQueryGetGraphicsScene = createReactQueryHook('getGraphicsScene', getGraphicsScene)
